import { Injectable } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeIdentityService {
  constructor(private readonly authService: AuthService) {}

  getCurrentEmployeeId(): number | null {
    return this.authService.getCurrentUserEmployeeId();
  }
}
